var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import { ResponsiveProp } from "@twilio-paste/style-props";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
var initDefaultSpacing = _ref => {
    let {
      prefix,
      responsive,
      defaultValue
    } = _ref;
    let getSpaceDefault = () => responsive ? new Array(3).fill(defaultValue) : defaultValue;
    return {
      [`${prefix}Top`]: getSpaceDefault(),
      [`${prefix}Bottom`]: getSpaceDefault(),
      [`${prefix}Right`]: getSpaceDefault(),
      [`${prefix}Left`]: getSpaceDefault()
    };
  },
  getDefaultSpacingValue = prefix => prefix === "margin" ? "auto" : "space0",
  getSpacing = (vertical, prefix, spacing) => {
    let defaultValue = getDefaultSpacingValue(prefix),
      computedSpacing = initDefaultSpacing({
        prefix,
        responsive: !1,
        defaultValue
      });
    return spacing === void 0 || (vertical ? (computedSpacing[`${prefix}Top`] = spacing, computedSpacing[`${prefix}Bottom`] = spacing) : (computedSpacing[`${prefix}Right`] = spacing, computedSpacing[`${prefix}Left`] = spacing)), computedSpacing;
  },
  getResponsiveSpacing = (vertical, prefix, spacing) => {
    let defaultValue = getDefaultSpacingValue(prefix),
      styles = {
        [`${prefix}Top`]: [defaultValue, defaultValue, defaultValue],
        [`${prefix}Bottom`]: [defaultValue, defaultValue, defaultValue],
        [`${prefix}Right`]: [defaultValue, defaultValue, defaultValue],
        [`${prefix}Left`]: [defaultValue, defaultValue, defaultValue]
      },
      spacingIsEmptyArray = Array.isArray(spacing) && spacing.length === 0;
    return spacing === void 0 || spacingIsEmptyArray || vertical.forEach((isVertical, screenSize) => {
      let spacingForScreenSize = Array.isArray(spacing) ? spacing[screenSize] : spacing;
      isVertical ? (styles[`${prefix}Top`][screenSize] = spacingForScreenSize, styles[`${prefix}Bottom`][screenSize] = spacingForScreenSize) : (styles[`${prefix}Right`][screenSize] = spacingForScreenSize, styles[`${prefix}Left`][screenSize] = spacingForScreenSize);
    }), styles;
  },
  getOuterGutterPull = gutter => Array.isArray(gutter) ? gutter.map(value => value !== "space0" ? value.replace("space", "spaceNegative") : value === "space0" ? "space0" : null) : gutter === "space0" ? "space0" : gutter && typeof gutter == "string" ? gutter.replace("space", "spaceNegative") : "auto",
  getStackedColumns = vertical => Array.isArray(vertical) ? vertical.map(value => typeof value == "boolean" ? value === !0 ? "100%" : "0" : null) : vertical ? "100%" : "0",
  getColumnPadding = _ref2 => {
    let {
      vertical,
      gutter
    } = _ref2;
    return Array.isArray(vertical) ? getResponsiveSpacing(vertical, "padding", gutter) : getSpacing(vertical, "padding", gutter);
  },
  getColumnSpan = _ref3 => {
    let {
      count,
      span
    } = _ref3;
    return Array.isArray(span) && count ? span.map(value => `${value / 12 * 100}%`) : typeof span == "number" && count && count <= 12 ? `${span / 12 * 100}%` : count !== void 0 ? `${1 / count * 100}%` : `${8.333333333333332}%`;
  },
  getColumnOffset = offset => Array.isArray(offset) ? offset.map(value => `${value / 12 * 100}%`) : `${offset / 12 * 100}%`;
var getGutterStyles = function (gutter) {
    let vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    let margin = getOuterGutterPull(gutter);
    return Array.isArray(vertical) ? getResponsiveSpacing(vertical, "margin", margin) : getSpacing(vertical, "margin", margin);
  },
  getFlexDirection = vertical => Array.isArray(vertical) ? vertical.map(value => typeof value == "boolean" && value === !0 ? "column" : "row") : vertical ? "column" : "row",
  Grid = React.forwardRef((_a, ref) => {
    var _b = _a,
      {
        as,
        children,
        element = "GRID",
        equalColumnHeights,
        gutter,
        marginTop,
        marginBottom,
        vertical = !1
      } = _b,
      props = __objRest(_b, ["as", "children", "element", "equalColumnHeights", "gutter", "marginTop", "marginBottom", "vertical"]);
    let GridColumns = React.useMemo(() => React.Children.map(children, child => React.isValidElement(child) ? React.cloneElement(child, {
        count: React.Children.count(children),
        gutter,
        vertical,
        stretchColumnContent: equalColumnHeights
      }) : child), [children, vertical, equalColumnHeights, gutter]),
      gutterStyles = React.useMemo(() => getGutterStyles(gutter, vertical), [gutter, vertical]),
      flexDirection = React.useMemo(() => getFlexDirection(vertical), [vertical]);
    return React.createElement(Box, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
      ref,
      as,
      alignItems: equalColumnHeights ? "stretch" : null,
      element,
      flexDirection,
      flexWrap: "wrap",
      display: "flex"
    }), gutterStyles), {
      marginTop,
      marginBottom,
      minWidth: "size0"
    }), GridColumns);
  });
Grid.displayName = "Grid";
import * as React2 from "react";
import PropTypes2 from "prop-types";
import { Box as Box2, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
import { ResponsiveProp as ResponsiveProp2 } from "@twilio-paste/style-props";
var getColumnStyles = _ref4 => {
    let {
      count,
      span,
      gutter,
      offset,
      vertical,
      stretchColumnContent
    } = _ref4;
    let columnStyles = __spreadValues({
      width: getColumnSpan({
        count,
        span
      })
    }, getColumnPadding({
      gutter,
      vertical
    }));
    return offset && (columnStyles.marginLeft = getColumnOffset(offset)), vertical && !offset && (columnStyles.minWidth = getStackedColumns(vertical), columnStyles.marginLeft = "space0"), stretchColumnContent && (columnStyles.alignContent = "stretch", columnStyles.display = "flex"), columnStyles;
  },
  Column = React2.forwardRef((_a, ref) => {
    var _b = _a,
      {
        as,
        children,
        count,
        element = "COLUMN",
        gutter,
        offset,
        span,
        stretchColumnContent,
        vertical
      } = _b,
      props = __objRest(_b, ["as", "children", "count", "element", "gutter", "offset", "span", "stretchColumnContent", "vertical"]);
    let ColumnStyles = React2.useMemo(() => getColumnStyles({
      count,
      gutter,
      offset,
      span,
      stretchColumnContent,
      vertical
    }), [count, gutter, offset, span, stretchColumnContent, vertical]);
    return React2.createElement(Box2, __spreadProps(__spreadValues(__spreadValues({}, safelySpreadBoxProps2(props)), ColumnStyles), {
      as,
      element,
      ref
    }), children);
  });
Column.displayName = "Column";
Column.propTypes = {
  as: PropTypes2.string,
  element: PropTypes2.string,
  offset: ResponsiveProp2(PropTypes2.number),
  span: ResponsiveProp2(PropTypes2.number)
};
export { Column, Grid };